export default __webpack_public_path__ + "static/ferrara-2358119877aad9e32ce4e3453cd7979b.png";